import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AddPlusSvg } from "../svgs/addPlusSvg";
import Search from "../containers/_services/search";
import Items from "../containers/_services/items";
import Loader from "../components/loader";
import Layout from "../layouts/layout";
import SERVICES from "../api/services/SERVICES";
import { paths } from "../routes/paths";
import styles from "../styles/_screens/services.module.scss";
import { ConfirmModal } from "../components/confirmModal";

const Services = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);

  const [responseStatus, setResponseStatus] = useState(null);

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalLoading, setConfirmModalLoading] = useState(false);

  // FETCH SERVICES
  useEffect(() => {
    setResponseStatus(null);
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await SERVICES.get_all({ business_id: businessId });
        setServices(res.data.data);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchData();
  }, [responseStatus]);

  // DELETE SERVICE
  const deleteService = async (id) => {
    setConfirmModalLoading(true);
    try {
      const res = await SERVICES.del(id);
      if (res.status === 200) {
        toast.success(res.data.message);
        setResponseStatus(true);
        setIsConfirmModalOpen(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
    setConfirmModalLoading(false);
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {/* <Search search={search} setSearch={setSearch} /> */}

          <div
            className={styles.add}
            data-tour="services-fab"
            onClick={() => navigate(paths.createService)}
          >
            <AddPlusSvg fill={"#000000"} />
            <p>הוספת שירות</p>
          </div>

          <div className={styles.main}>
            {loading ? (
              <Loader />
            ) : (
              <Items
                services={services}
                deleteService={deleteService}
                setIsConfirmModalOpen={setIsConfirmModalOpen}
              />
            )}
          </div>
        </div>

        {isConfirmModalOpen && (
          <ConfirmModal
            setIsOpen={setIsConfirmModalOpen}
            handleClick={() => deleteService(isConfirmModalOpen)}
            loading={confirmModalLoading}
          />
        )}
      </div>
    </Layout>
  );
};

export default Services;
